export default __webpack_public_path__ + "static/media/474.88ffe743.gif";